// @flow
import React from 'react'

type Props = {
  name: string,
  className?: string,
  spin?: boolean,
  fw?: boolean,
  size?: 'lg' | number,
}

const Icon = ({ className, name, spin, size, fw, ...rest }: Props) => {
  let iconClass = `fi fi-${name}`

  if (spin) iconClass += ' fi-spin'
  if (size) {
    const realSize = size === 'lg' ? size : `${size}x`
    iconClass += ` fi-${realSize}`
  }
  if (fw) iconClass += ' fi-fw'
  if (className) iconClass += ` ${className}`

  return <span {...rest} className={iconClass} />
}

export default Icon



// WEBPACK FOOTER //
// ./src/bui/ui/Icon.js